<template>
  <div v-if="ready" class="epic-widget-launcher">
    <!-- Wraps the modal so the selects in its body and the submit button in its actions belong to one form. -->
    <form class="epic-widget-launcher__form" :action="formAction" method="post" target="_blank" @submit="close">
      <input v-if="csrfToken" type="hidden" :name="csrfParam" :value="csrfToken" />
      <input v-if="physicianId" type="hidden" name="physician_id" :value="physicianId" />
      <input v-if="visitTypeId" type="hidden" name="visit_type_id" :value="visitTypeId" />

      <sp-modal
        :open="open"
        :modal-title="t('title')"
        :label="t('title')"
        width="min(44rem, 90vw)"
        @update-open="handleUpdateOpen"
      >
        <sp-button slot="activator" :variant="activatorVariant" :data-testid="TestId.epicWidgetLauncher.activator">
          {{ t("activator_label") }}
        </sp-button>

        <EpicWidgetLauncherFields />

        <EpicWidgetLauncherActions slot="actions" />
      </sp-modal>
    </form>
  </div>
</template>

<script setup>
import { onMounted, provide, ref } from "vue";
import { TestId } from "#/test-ids";
import { createEpicWidgetLauncherApi } from "#ce/apps/SpAdmin/SpEpicWidgetLauncher/api/epic-widget-launcher";
import EpicWidgetLauncherActions from "#ce/apps/SpAdmin/SpEpicWidgetLauncher/components/EpicWidgetLauncherActions.ce.vue";
import EpicWidgetLauncherFields from "#ce/apps/SpAdmin/SpEpicWidgetLauncher/components/EpicWidgetLauncherFields.ce.vue";
import { t, whenI18nReady } from "./i18n";
import { props as appProps } from "./props.js";
import {
  EPIC_WIDGET_LAUNCHER_KEY,
  createEpicWidgetLauncherStore,
} from "#ce/apps/SpAdmin/SpEpicWidgetLauncher/store/epic-widget-launcher";

const props = defineProps(appProps);

const store = createEpicWidgetLauncherStore({
  api: createEpicWidgetLauncherApi(props.optionsUrl),
  physicianId: props.physicianId,
});
provide(EPIC_WIDGET_LAUNCHER_KEY, store);
const { open, setOpen, close } = store;

const csrfParam = document.querySelector('meta[name="csrf-param"]')?.content;
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

const ready = ref(false);

function handleUpdateOpen({ detail }) {
  setOpen(detail[0]);
}

async function markReady() {
  await whenI18nReady;
  ready.value = true;
}

onMounted(markReady);
</script>

<style>
:host {
  display: block;
}

/* In an Information panel the activator reads as the panel's other links. */
:host([activator-variant="appearance-link-inline"]) {
  --sp-comp-button-appearance-link-text-color: currentColor;
  --sp-comp-button-appearance-link-text-decoration: none;
}
</style>

<style scoped lang="scss">
.epic-widget-launcher {
  --sp-comp-modal-padding-block: var(--sp-ref-scale-16);

  &__form {
    display: contents;
  }
}
</style>
